import * as React from "react";

function IconFlag2Off({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-flag-2-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/flag-2-off"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 14h9m4 0h1v-9h-10m-4 0v16" /><path d="M3 3l18 18" /></svg>;
}

export default IconFlag2Off;